var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReading4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D0FFCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.75L16.925 23.6374C16.404 22.856 16.1435 22.4652 15.7993 22.1824C15.4946 21.9319 15.1436 21.7441 14.7662 21.6295C14.3399 21.5 13.8703 21.5 12.9311 21.5H11.9C11.0599 21.5 10.6399 21.5 10.319 21.3365C10.0368 21.1927 9.8073 20.9632 9.66349 20.681C9.5 20.3601 9.5 19.9401 9.5 19.1V12.65C9.5 11.8099 9.5 11.3899 9.66349 11.069C9.8073 10.7868 10.0368 10.5573 10.319 10.4135C10.6399 10.25 11.0599 10.25 11.9 10.25H12.2C13.8802 10.25 14.7202 10.25 15.362 10.577C15.9265 10.8646 16.3854 11.3235 16.673 11.888C17 12.5298 17 13.3698 17 15.05M17 23.75V15.05M17 23.75L17.075 23.6374C17.596 22.856 17.8565 22.4652 18.2007 22.1824C18.5054 21.9319 18.8564 21.7441 19.2338 21.6295C19.6601 21.5 20.1297 21.5 21.0689 21.5H22.1C22.9401 21.5 23.3601 21.5 23.681 21.3365C23.9632 21.1927 24.1927 20.9632 24.3365 20.681C24.5 20.3601 24.5 19.9401 24.5 19.1V12.65C24.5 11.8099 24.5 11.3899 24.3365 11.069C24.1927 10.7868 23.9632 10.5573 23.681 10.4135C23.3601 10.25 22.9401 10.25 22.1 10.25H21.8C20.1198 10.25 19.2798 10.25 18.638 10.577C18.0735 10.8646 17.6146 11.3235 17.327 11.888C17 12.5298 17 13.3698 17 15.05",
    stroke: "#1ED214",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading4);
export default __webpack_public_path__ + "static/media/reading4.1d0fcc15f18c87afc349e6ce8aac935d.svg";
export { ForwardRef as ReactComponent };